import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';

const { FiBell } = FiIcons;

const BookingNotification = () => {
  const [isVisible, setIsVisible] = useState(false);
  
  useEffect(() => {
    // Check if notification has already been shown in this session
    const notificationShown = sessionStorage.getItem('notificationShown');
    
    if (!notificationShown) {
      // Show notification after 39 seconds
      const timer = setTimeout(() => {
        setIsVisible(true);
        sessionStorage.setItem('notificationShown', 'true');
        
        // Hide notification after 5 seconds
        setTimeout(() => {
          setIsVisible(false);
        }, 5000);
      }, 39000);
      
      return () => clearTimeout(timer);
    }
  }, []);
  
  // Don't render anything if not visible to save memory
  if (!isVisible) return null;
  
  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ opacity: 0, x: -100, y: 0 }}
          animate={{ opacity: 1, x: 0, y: 0 }}
          exit={{ opacity: 0, x: -100 }}
          transition={{ duration: 0.5 }}
          className="fixed bottom-4 left-4 bg-gradient-to-r from-green-600 to-green-700 text-white px-4 py-3 rounded-xl shadow-2xl z-50 max-w-xs"
        >
          <div className="flex items-start space-x-3">
            <div className="w-8 h-8 bg-white rounded-full flex items-center justify-center flex-shrink-0">
              <SafeIcon icon={FiBell} className="text-green-600 animate-pulse" />
            </div>
            <div>
              <p className="font-semibold">ขณะนี้มีการจองเข้ามาแล้ว 1 คน</p>
              <p className="text-green-100 text-xs mt-1">เมื่อ 2 นาทีที่แล้ว</p>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default BookingNotification;